/**
 * Query keys da comissão de professores (/comissoes). As raízes são as MESMAS
 * strings que o CRM já invalidava antes da factory (`useExpenses` invalida
 * `['teacher_commission_statements']` ao pagar a despesa da comissão) — mudar
 * o prefixo quebraria essas invalidações.
 */
import { tuple } from "./core";

const statementsRoot = ["teacher_commission_statements"] as const;
const itemsRoot = ["teacher_commission_items"] as const;
const rulesRoot = ["teacher_commission_rules"] as const;

export const commissions = {
  statements: {
    /** Prefixo — gerar/aprovar/reabrir/pagar/cancelar invalidam isto. */
    all: statementsRoot,
    /** Lista paginada com os filtros (chave estável de `chaveDosFiltros`). */
    list: (clubId: string | null | undefined, filtros: string, from: number, to: number) =>
      tuple(statementsRoot, "list", clubId, filtros, from, to),
    /** Um fechamento pelo id (o diálogo de detalhe). */
    byId: (statementId: string | null | undefined) => tuple(statementsRoot, "byId", statementId),
  },
  items: {
    all: itemsRoot,
    byStatement: (statementId: string | null | undefined) => tuple(itemsRoot, statementId),
  },
  rules: {
    all: rulesRoot,
    byClub: (clubId: string | null | undefined) => tuple(rulesRoot, clubId),
  },
} as const;
